import keyBy from 'lodash/keyBy';

export function getStopStatusReasonCodeList(groupedStopStatusReasonCodes) {
  return groupedStopStatusReasonCodes.reduce((flat, group) => [...flat, ...group.options], []);
}

export function getStopStatusReasonCodeMap(groupedStopStatusReasonCodes) {
  return keyBy(getStopStatusReasonCodeList(groupedStopStatusReasonCodes), (reason) => reason.id);
}
